<script setup lang="ts">
import Collapsible from '@/components/Collapsible.vue';
import StylessButton from '@/components/StylessButton.vue';
import { computed } from 'vue';

const props = withDefaults(defineProps<{
    selected?: number;
}>(), {
    selected: undefined
});

const emits = defineEmits<{
    (e: 'change', rating?: number): void
}>();

const clearSelected = () => {
    emits('change');
}

const onRatingSelect = (rating: number) => {
    if (rating === props.selected) {
        emits('change');
    } else {
        emits('change', rating);
    }
}

const ratingOptions = computed(() => [5, 4, 3, 2, 1]);
</script>

<template>
    <Collapsible class="ic-filter" default-open>
        <template #header="{ toggle, isOpen }">
            <button class="btn btn-link w-100 accordion-toggle" @click="toggle">
                <span class="h4 ic-filter-title">Waardering</span>
                <span class="m-0 icon icon-chevron--down" :class="isOpen ? 'up' : 'down'" aria-hidden="true" />
            </button>
        </template>

        <template #default>

            <div v-for="stars in ratingOptions" :key="`star-${stars}`" class="custom-control custom-radio">
                <label class="w-100">
                    <input type="radio" class="custom-control-input" :value="stars" :checked="stars === selected"
                        @change="onRatingSelect(stars)" />
                    <span class="custom-control-label custom-control-label--stars">
                        <span v-for="i in 5" :key="`star-${stars}-${i}`"
                            :class="i <= stars ? 'icon icon-star-active' : 'icon icon-star'"></span>
                        <StylessButton v-if="stars === selected" @click="clearSelected" ariaLabel="Sluit" class="ml-auto">
                            <span class="icon icon-close" aria-hidden="true" />
                        </StylessButton>
                    </span>
                </label>
            </div>
        </template>
    </Collapsible>
</template>